import React from "react";

import useTimeOut from "../hooks/useTimeOut";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  helpImageContainer: {
    aspectRatio: "2/1",
    width: "100%",
    position: "relative",
    overflow: "hidden",
  },
  helpImage: {
    width: "100%",
    borderRadius: "6px",
    aspectRatio: "2/1",
    backgroundSize: "cover",
    backgroundColor: "#D9D9D9",
    margin: "1rem 0 0 0",
  },
  tipLabel: {
    margin:0,
    fontSize: 14,
    color: "#303030",
  },
}));

export default function FeaturesCarousel({ imageBaseUrl, images, enabled }) {
  const classes = useStyles();

  const { timeOut } = useTimeOut({
    enabled,
    onTimeOut: () => {},
    duration: 5000,
  });

  const imageIndex =
    timeOut > images.length - 1 ? timeOut % images.length : timeOut;

  const image = images[imageIndex];

  const renderFeaturesCarousel = () => {
    return (
      <>
        <div className={classes.helpImageContainer}>
          {images.map((image, i) => {
            return (
              <div
                key={image.imagePath}
                className={classes.helpImage}
                style={{
                  backgroundImage: `url('${imageBaseUrl}/${image.imagePath}')`,
                  opacity: imageIndex === i ? 1 : 0,
                  position: "absolute",
                  left: 0,
                  top: 0,
                }}
              />
            );
          })}
        </div>

        <div style={{ padding: "1rem 0" }}>
          <p className={classes.tipLabel}>{image.title}</p>
        </div>
      </>
    );
  };

  return renderFeaturesCarousel();
}
